import { Inject, ISimpleControllerConfiguration, SimpleBaseController } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/GameModel';
import { OkUI } from './UI/OkUI';
import { VkUI } from './UI/VkUI';

export interface ISocialControllerOptions {}

export class SocialController extends SimpleBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: ISocialControllerOptions,
                       @Inject private vkUI: VkUI,
                       @Inject private okUI: OkUI) {
        super('SocialController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return <ISimpleControllerConfiguration>{
            childControllers: {},
        };
    }

    protected onInitialize() {
        // временно
        // let ui = window.location.href.indexOf('vk.com') > 0 ? this.socialVK : this.okUI;
        const ui = this.vkUI;
        this.display.addChild(ui);
    }

    
}